// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2TOi9","title":"FrontImage_title__1BALD"};